import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Spinner from "../../components/Spinner";
import { toast } from "react-toastify";
import Modal from "../../components/Modal";
import { IoMdClose } from "react-icons/io";
import { IoCheckmark, IoCloudyNight } from "react-icons/io5";
import remove_recipient from "../../assets/icons/remove_recipient.svg";
import GenerateCardPopup from "../../components/GenerateCardPopup";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const AddRecipient = () => {
  const [cancelModal, setCancelModal] = useState(false);
  const [data, setData] = useState({
    customerId: "",
    fullName: "",
    dob: "",
    relationShip: "",
    gender: "",
    characterTraits: [],
    email: "",
    anniversaryDate: "",
    streetAddress: "",
    city: "",
    stateId: "",
    zipCode: "",
  });
  const [selectedOccasion, setSelectedOccasion] = useState([]);
  const [states, setStates] = useState([]);
  const [occasion, setOccasion] = useState([]);

  const [status, setStatus] = useState("");
  const [orderModal, setOrderModal] = useState(false);
  const animatedComponents = makeAnimated();

  const toggleCancelModal = () => {
    setCancelModal(!cancelModal);
  };

  const toggleOrderModal = () => {
    setOrderModal(!orderModal);
  };

  useEffect(() => {
    const recipientData = JSON.parse(localStorage.getItem("recipientData"));
    if (recipientData) {
      setData(recipientData);
    }
  }, []);

  useEffect(() => {
    const fetchOccasion = async () => {
      const token = localStorage?.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/event/get-active-event`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const res = await response.json();
      const status = res.code;
      if (status === 200) {
        setOccasion(res.data);
      }
    };
    fetchOccasion();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/state/active_state_listing`
      );
      const res = await response.json();
      const status = res.code;
      if (status === 200) {
        setStates(res.data);
      }
    };
    fetchStates();
  }, []);

  const handleOccasionChange = (selectedOptions) => {
    setSelectedOccasion(selectedOptions);
    const eventId = selectedOccasion.map((occasion) => occasion.value);
    // Map over the selected options and extract the value (occasion._id) from each
    setData({ ...data, eventsId: eventId });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleGenderSelection = (gender) => {
    setData({ ...data, gender });
  };

  const isTraitSelected = (trait) => data.characterTraits.includes(trait);

  const handleTraitSelection = (trait) => {
    // Check if the trait is already in the array
    if (data.characterTraits.includes(trait)) {
      // Remove the trait if it's already in the array
      setData({
        ...data,
        characterTraits: data.characterTraits.filter((t) => t !== trait),
      });
    } else {
      // Add the trait if it's not in the array
      setData({
        ...data,
        characterTraits: [...data.characterTraits, trait],
      });
    }
  };

  const isGenderSelected = (gender) => data.gender === gender;

  const handleSave = () => {
    if (status === "Single") {
      delete data.anniversaryDate;
    }
    if (data.characterTraits.length < 3) {
      toast.error("Please select at least 3 character traits");
      return;
    }
    localStorage.setItem("recipientData", JSON.stringify(data));
    window.location.href = "/signup";
  };

  return (
    <div className="xl:m-10 m-3">
      {cancelModal && (
        <Modal toggleCancelModal={toggleCancelModal}>
          <div className="flex flex-col items-center justify-center">
            <div className="bg-[#383634] w-full h-fit p-2 px-4 py-3 rounded-t-xl rounded-tl-xl flex items-center justify-between">
              <h1 className="text-2xl text-white">Cancel Add Recipient</h1>
              <IoMdClose
                size={30}
                color="white"
                className="cursor-pointer"
                onClick={toggleCancelModal}
              />
            </div>
            <div className="border-2 border-black border-dashed p-5 m-10 rounded-lg flex flex-col items-center justify-center">
              <img
                src={remove_recipient}
                alt="remove_recipient"
                className="w-[40%] m-5"
              />
              <p className="text-center my-3 text-lg">
                Are you sure you want to Cancel this Add Recipient Process?
              </p>
              <div className="flex items-center justify-center gap-x-4 w-full text-xl">
                <button
                  className="border-2 border-primary text-primary hover:bg-gray-100 py-2 px-8 rounded-sm flex items-center justify-center gap-x-2"
                  onClick={toggleCancelModal}
                >
                  <IoMdClose size={30} />
                  <span className="font-medium">No</span>
                </button>
                <Link to="/dashboard/address_book">
                  <button className="bg-primary hover:bg-primary-dark border-2 border-primary text-white py-2 px-8 rounded-sm flex items-center justify-center gap-x-2">
                    <IoCheckmark size={30} />
                    <span className="font-medium">Yes</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {orderModal && (
        <GenerateCardPopup toggleOrderModal={toggleOrderModal} ID="" />
      )}
      <div className="sm:p-5 py-3 flex items-center justify-between border-b-2 gap-5 border-gray-300">
        <h1 className="text-3xl font-semibold w-full flex-1">Add Recipients</h1>
      </div>
      <div className="md:mx-52 my-10">
        <h1 className="text-2xl font-semibold">General Information</h1>
        <div className="flex flex-col xl:m-10 my-3 w-full">
          <div className="flex md:flex-row flex-col w-full">
            <div className="flex flex-col w-full mr-10">
              <label className="my-2 text-lg text-gray-400">Full Name</label>
              <input
                type="text"
                name="fullName"
                value={data.fullName}
                onChange={handleChange}
                required
                placeholder="Please enter Recipients full name"
                className="bg-none border-b-2 py-3 focus:outline-none border-gray-300 placeholder:text-gray-300 w-full"
              />
            </div>
            <div className="flex flex-col w-full">
              <label className="my-2 text-lg text-gray-400">Relationship</label>
              <select
                className="bg-white border-b-2 border-gray-300 py-3 w-full"
                name="relationShip"
                value={data.relationShip}
                required
                onChange={handleChange}
              >
                <option value="">--Select--</option>
                <option value="Father">Father</option>
                <option value="Mother">Mother</option>
                <option value="Uncle">Uncle</option>
                <option value="Aunt">Aunt</option>
                <option value="Both Parents">Both Parents</option>
                <option value="Husband">Husband</option>
                <option value="Wife">Wife</option>
                <option value="A Couple">A Couple</option>
                <option value="Son">Son</option>
                <option value="Daughter">Daughter</option>
                <option value="Sister">Sister</option>
                <option value="Brother">Brother</option>
                {/* <option value="GF">GF</option> */}
                {/* <option value="BF">BF</option> */}
                <option value="Grandad">Grandad</option>
                <option value="Grandmom">Grandmom</option>
                <option value="Grandson">Grandson</option>
                <option value="Grandaughter">Grandaughter</option>
              </select>
            </div>
          </div>
          <div className="flex xl:flex-row flex-col items-center w-full">
            <div className="flex flex-col w-full">
              <label className="my-2 text-lg text-gray-400 ">Birthday</label>
              <input
                type="date"
                name="dob"
                value={data.dob}
                onChange={handleChange}
                required
                max={new Date().toISOString().split("T")[0]}
                placeholder="00/00/0000"
                className="py-3 bg-none border-b-2 border-gray-300  focus:outline-none placeholder:text-gray-300 xl:w-[90%] w-full mr-6 mb-6 relative top-3"
              />
            </div>
            <div className="flex flex-col w-full">
              <label className="my-2 text-lg text-gray-400">E-mail</label>
              <input
                type="email"
                name="email"
                value={data.email}
                onChange={handleChange}
                placeholder="Please enter your e-mail"
                className="py-3 bg-none border-b-2  focus:outline-none border-gray-300 placeholder:text-gray-300 w-full"
              />
            </div>
          </div>
          <h3 className="text-lg text-gray-400 mt-3">Marital status</h3>
          <select
            className="bg-white border-b-2 border-gray-300 py-3 w-full"
            name="status"
            value={status}
            required
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="">--Select--</option>
            <option value="Single">Single</option>
            <option value="Married">Married</option>
          </select>
          {status === "Married" && (
            <div className="flex flex-col w-full my-3">
              <label className="my-2 text-lg text-gray-400 ">
                Anniversary Date
              </label>
              <input
                type="date"
                name="anniversaryDate"
                value={data.anniversaryDate}
                onChange={handleChange}
                required
                placeholder="00/00/0000"
                className="py-3 bg-none border-b-2  focus:outline-none border-gray-300 placeholder:text-gray-300 w-full mr-6 mb-6"
              />
            </div>
          )}
          <h3 className="text-lg text-gray-400 mt-3">Gender</h3>
          <div className="flex items-center my-5 gap-x-5">
            <button
              className={`xl:px-20 w-full rounded-md py-2 flex items-center justify-center text-xl border-2 ${
                isGenderSelected("male")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleGenderSelection("male")}
            >
              Male 🧔🏻‍
            </button>
            <button
              className={`xl:px-20 w-full rounded-md py-2 flex items-center justify-center text-xl border-2 ${
                isGenderSelected("female")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleGenderSelection("female")}
            >
              Female 👩🏻
            </button>
          </div>
          <div className="flex flex-col w-full mb-5">
            <label className="text-lg text-gray-400">Occasion</label>
            <Select
              styles={{
                control: (baseStyles, { isFocused }) => ({
                  ...baseStyles,
                  padding: "5px",
                  borderRadius: "5px",
                  border: "2px solid #bbb",
                }),
                multiValue: (styles) => ({
                  ...styles,
                  backgroundColor: "#F66",
                  borderRadius: "10px",
                }),
                multiValueLabel: (styles) => ({
                  ...styles,
                  color: "white",
                  padding: "5px",
                }),
                multiValueRemove: (styles) => ({
                  ...styles,
                  color: "white",
                  ":hover": {
                    backgroundColor: "#F660",
                    color: "white",
                  },
                  borderRadius: "10px",
                }),
                option: (styles, { isFocused, isSelected }) => ({
                  ...styles,
                  backgroundColor: isFocused
                    ? "#CE921B"
                    : isSelected
                    ? "#CE921B"
                    : null,
                  color: isFocused || isSelected ? "white" : "#CE921B",
                  ":active": {
                    ...styles[":active"],
                    backgroundColor: isSelected ? "#CE921B" : null,
                  },
                }),
              }}
              className="my-3"
              closeMenuOnSelect={false}
              components={animatedComponents}
              isMulti
              required
              options={occasion?.map((occasion) => ({
                value: occasion._id,
                label: occasion.name,
              }))}
              onChange={handleOccasionChange}
              value={selectedOccasion}
            />
          </div>
          <h3 className="text-lg text-gray-400">
            Character Traits (Multiple Select){" "}
          </h3>
          <div className="grid lg:grid-cols-4 grid-cols-3 gap-2 place-items-center my-3">
            <button
              className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
                isTraitSelected("Kind")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleTraitSelection("Kind")}
            >
              Kind
            </button>
            <button
              className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
                isTraitSelected("Loving")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleTraitSelection("Loving")}
            >
              Loving
            </button>
            <button
              className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
                isTraitSelected("Wise")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleTraitSelection("Wise")}
            >
              Wise
            </button>
            <button
              className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
                isTraitSelected("Honest")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleTraitSelection("Honest")}
            >
              Honest
            </button>
            <button
              className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
                isTraitSelected("Generous")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleTraitSelection("Generous")}
            >
              Generous
            </button>
            <button
              className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
                isTraitSelected("Humorous")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleTraitSelection("Humorous")}
            >
              Humorous
            </button>
            <button
              className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
                isTraitSelected("Compasionate")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleTraitSelection("Compasionate")}
            >
              Compasionate
            </button>
            <button
              className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
                isTraitSelected("Patient")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleTraitSelection("Patient")}
            >
              Patient
            </button>
            <button
              className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
                isTraitSelected("Adventurous")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleTraitSelection("Adventurous")}
            >
              Adventurous
            </button>
            <button
              className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
                isTraitSelected("Gentle")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleTraitSelection("Gentle")}
            >
              Gentle
            </button>
            <button
              className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
                isTraitSelected("Loyal")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleTraitSelection("Loyal")}
            >
              Loyal
            </button>
            <button
              className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
                isTraitSelected("Creative")
                  ? "bg-primary-light border-primary"
                  : "border-gray-500 hover:border-primary"
              }`}
              onClick={() => handleTraitSelection("Creative")}
            >
              Creative
            </button>
          </div>
        </div>
        <h1 className="text-2xl font-semibold">Location Detail</h1>
        <div className="flex flex-col xl:m-10 my-3 w-full">
          <div className="flex flex-col w-full my-2">
            <label className="text-lg text-gray-400">Street Address</label>
            <input
              type="text"
              name="streetAddress"
              value={data.streetAddress}
              required
              onChange={handleChange}
              className="py-3 bg-none border-b-2 focus:outline-none border-gray-300 placeholder:text-gray-300 w-full"
            />
          </div>
          <div className="flex flex-col w-full my-2">
            <label className="text-lg text-gray-400">City</label>
            <input
              type="text"
              name="city"
              value={data.city}
              required
              onChange={handleChange}
              className="py-3 bg-none border-b-2 focus:outline-none border-gray-300 placeholder:text-gray-300 w-full"
            />
          </div>
          <div className="flex flex-col w-full my-2">
            <label className="text-lg text-gray-400">Zip Code</label>
            <input
              type="number"
              name="zipCode"
              value={data.zipCode}
              required
              onChange={handleChange}
              className="py-3 bg-none border-b-2 focus:outline-none border-gray-300 placeholder:text-gray-300 w-full"
            />
          </div>
          <div className="flex flex-col w-full my-2">
            <label className="text-lg text-gray-400">State</label>
            <select
              name="stateId"
              value={data.stateId}
              onChange={handleChange}
              required
              className="py-3 bg-white border-b-2 border-gray-300 placeholder:text-gray-300 w-full"
            >
              <option value="">Choose State</option>
              {states.map((state) => (
                <option key={state._id} value={state._id}>
                  {state.state}
                </option>
              ))}
            </select>
          </div>
          <div className="flex md:flex-row flex-col items-center gap-3 flex-grow mt-20">
            <button
              onClick={handleSave}
              className="bg-primary rounded-md py-3 sm:px-10 px-5 text-white sm:text-xl w-full hover:bg-primary-light"
            >
              Save
            </button>
            <button
              onClick={toggleCancelModal}
              className="bg-primary rounded-md py-3 sm:px-10 px-5 text-white sm:text-xl w-full hover:bg-primary-light"
            >
              Cancel
            </button>

            {/* <button
              onClick={handleSave}
              className="bg-primary rounded-md py-3 sm:px-10 px-5 text-white sm:text-xl w-full hover:opacity-90"
            >
              Save & Generate
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddRecipient;
